"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLayoutSectionHandler = void 0;
var tslib_1 = require("tslib");
var general_1 = require("../../events/general");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var layout_1 = require("../../store/layout");
var layout_2 = require("../../events/layout");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var layoutValidation_1 = require("./validation/layoutValidation");
var arrayOps_1 = require("../../utils/arrayOps");
function removeLayoutSectionHandler(ctx, cmd) {
    var layout, _a, index, stashIdentifier, absoluteIndex, section;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectLayout)];
            case 1:
                layout = _b.sent();
                _a = cmd.payload, index = _a.index, stashIdentifier = _a.stashIdentifier;
                if (isEmpty_1.default(layout.sections)) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Attempting to remove a section from an empty layout.");
                }
                if (!layoutValidation_1.validateSectionExists(layout, index)) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Attempting to remove non-existing layout section at index " + index + ".");
                }
                absoluteIndex = arrayOps_1.resolveRelativeIndex(layout.sections, index);
                section = layout.sections[absoluteIndex];
                return [4 /*yield*/, effects_1.put(layout_1.layoutActions.removeSection({
                        index: absoluteIndex,
                        stashIdentifier: stashIdentifier,
                        undo: {
                            cmd: cmd,
                        },
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/, layout_2.layoutSectionRemoved(ctx, section, absoluteIndex, false, stashIdentifier, cmd.correlationId)];
        }
    });
}
exports.removeLayoutSectionHandler = removeLayoutSectionHandler;
//# sourceMappingURL=removeLayoutSectionHandler.js.map